import { SVG, SVGProps } from './svg'

export function IconTrendingUp(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22 5.5v5a.5.5 0 0 1-.5.5h-.29a.49.49 0 0 1-.36-.15l-1.64-1.64-5.36 5.35a.48.48 0 0 1-.7 0l-2.65-2.65-6.94 6.94a.5.5 0 0 1-.71 0l-.7-.7a.5.5 0 0 1 0-.71l8-8a.48.48 0 0 1 .7 0l2.65 2.65 4.29-4.3-1.64-1.64a.49.49 0 0 1-.15-.36V5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Z" />
    </SVG>
  )
}
